import React, { memo, useState } from 'react'
import {
  Alert,
  Button, Card, Dialog,
} from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import InputFile from '../../../components/InputFile/InputFile'
import { useForm } from 'react-hook-form'
import Typography from '@mui/material/Typography'
import CheckIcon from '@material-ui/icons/Check'
import Modal from '@mui/material/Modal'
import CloseIcon from '@material-ui/icons/Close'
import {Group} from "@material-ui/icons";
import Box from "@mui/material/Box";
import GetAppIcon from '@material-ui/icons/GetApp';
import {transformFileToBase64} from "../../../utils";

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  containerAlert: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 16,
  },
  cardDialog: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  btnGroup: {
    display:'flex',
    justifyContent:'space-between',
  },
  alertInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}))

export default memo(({ setStep, setFilesStep4, withActivites }) => {
  const classes = styles()
  const [openModal, setOpenModal] = useState(false)
  const { register, handleSubmit } = useForm({
    defaultValues: {
      justificatif: null,
      photo_identite: null,
      cni: null,
      fiche_renseignement: null,
      piece_handicap: null
    }
  })

  const [files, setFiles] = useState({
    justificatif: null,
    photo_identite: null,
    cni: null,
    fiche_renseignement: null,
    piece_handicap: null,
  })

  const [requiredFiles, setRequiredFiles] = useState([
    'justificatif',
    'photo_identite',
    'cni',
    'fiche_renseignement',
  ])

  const handleFileChange = (name) => (event) => {
    const file = event.target.files[0]
    transformFileToBase64(file).then((base64) => {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [name]: base64,
      }))
    })
  }

  const missingRequiredFiles = requiredFiles.filter(
    (fileKey) => !files[fileKey]
  )

  const isSubmitDisabled = missingRequiredFiles.length > 0

  const onSubmit = (data) => {
    setOpenModal(true)
  }

  const handleConfirmDialog = () => {
    setOpenModal(false)
    setFilesStep4(files)
    setStep(5)
  }

  return (
    <>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <Card variant="outlined" sx={{ padding: 2 }} className={classes.cardDialog}>
          <Typography variant="h6">Confirmation documents</Typography>
          <Typography>
            Veuillez confirmer que les documents sont corrects.
            {!withActivites && ' En confirmant, vous aurez terminé la soumission de votre dossier'}
          </Typography>
          <Box className={classes.btnGroup}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpenModal(false)}
              startIcon={<CloseIcon />}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleConfirmDialog}
              startIcon={<CheckIcon />}
            >
              Confirmer
            </Button>
          </Box>
        </Card>
      </Dialog>

      <div className={classes.containerAlert}>
        <Alert severity="info" style={{alignItems: 'start'}}>
          <div className={classes.alertInfo}>
            <div>
              Vous avez la possibilité de télécharger et imprimer le document d'inscription en cliquant sur le bouton ci-dessous.
            </div>
            <Button
              type="submit"
              variant="contained"
              color="info"
              startIcon={<GetAppIcon />}
            >
              Document d'inscription
            </Button>
          </div>

        </Alert>

      </div>

      <form onSubmit={handleSubmit(onSubmit)} className={classes.container}>
        <InputFile
          label="Justificatif de domicile"
          required
          onChange={handleFileChange('justificatif')}
          name="justificatif"
        />
        <InputFile
          label="Photo d'identité"
          required
          onChange={handleFileChange('photo_identite')}
          name="photo_identite"
        />
        <InputFile
          label="CNI Recto/Verso"
          required
          onChange={handleFileChange('cni')}
          name="cni"
        />
        <InputFile
          label="Fiche de renseignement"
          required
          onChange={handleFileChange('fiche_renseignement')}
          name="fiche_renseignement"
        />
        <InputFile
          label="Pièce jointe - Handicap"
          onChange={handleFileChange('piece_handicap')}
          name="piece_handicap"
        />
        {isSubmitDisabled && (
          <Alert severity="warning" className={classes.alert}>
            Veuillez joindre les fichiers obligatoires suivants :{' '}
            {missingRequiredFiles.join(', ')}
          </Alert>)}
        <Button
          type="submit"
          variant="contained"
          color="success"
          disabled={isSubmitDisabled}
          startIcon={<CheckIcon />}
        >
          Soumettre
        </Button>
      </form>
    </>
  )
})
